// extracted by mini-css-extract-plugin
export var dividerLine = "_5u-3";
export var itemImage = "_5u-9";
export var lightDivider = "_5u-4";
export var modalContent = "_5u-5";
export var modalContentCompact = "_5u-6";
export var productCard = "_5u-a";
export var productImage = "_5u-b";
export var productImageCompact = "_5u-7";
export var productImagePlaceholder = "_5u-c";
export var productImagePlaceholderCompact = "_5u-8";
export var progressBarBackground = "_5u-1";
export var progressBarContainer = "_5u-0";
export var progressBarFill = "_5u-2";